export default {
  mutations: {
    SET_OPERATION_TYPES_LIST: 'SET_OPERATION_TYPES_LIST',
  },
  getters: {
    GET_OPERATION_TYPES_LIST: 'GET_OPERATION_TYPES_LIST',
  },
  actions: {
    OPERATION_TYPES_LIST: 'OPERATION_TYPES_LIST',
  },
};
